export const getTrustedCaptrixonOrigins = (captrixonUrl: string): string[] => {
  try {
    return [new URL(captrixonUrl).origin];
  } catch {
    return [];
  }
};

export const isTrustedRedirectUrl = (
  redirectUrl: string,
  trustedOrigins: string[],
): boolean => {
  if (!redirectUrl || !trustedOrigins?.length) {
    return false;
  }

  try {
    const parsedTarget = new URL(redirectUrl);
    const isHttpProtocol =
      parsedTarget.protocol === 'https:' || parsedTarget.protocol === 'http:';

    return isHttpProtocol && trustedOrigins.includes(parsedTarget.origin);
  } catch {
    return false;
  }
};

export const redirectToTrustedUrl = (
  redirectUrl: string,
  trustedOrigins: string[],
  fallbackUrl?: string,
): boolean => {
  if (isTrustedRedirectUrl(redirectUrl, trustedOrigins)) {
    window.location.assign(redirectUrl);
    return true;
  }

  if (fallbackUrl && isTrustedRedirectUrl(fallbackUrl, trustedOrigins)) {
    window.location.assign(fallbackUrl);
    return true;
  }

  return false;
};
